module.exports = {
  ENV: process.env.REACT_PUBLIC_ENV,
  BaseURL: process.env.REACT_APP_BASE_URL,
  GC_MAP_KEY: process.env.REACT_APP_GC_MAP_KEY
};
